<dx-data-grid
  id="fieldCropsGridContainer"
  [dataSource]="ds"
  [libGridDefault]="{ stateStorageKey: 'app-crop-fields-grid' }"
  [columnHidingEnabled]="false"
  (onInitNewRow)="checkClone($event)"
  (onEditingStart)="onEditingStart($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)"
>
  <dxi-column
    caption="ID"
    width="8%"
    dataField="id"
    sortOrder="desc"
    [allowEditing]="false"
    [formItem]="{ visible: false }"
    dataType="number"
  >
  </dxi-column>

  <dxi-column
    caption="Nom"
    width="auto"
    [allowEditing]="false"
    [formItem]="{ visible: false }"
    dataField="name"
  >
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Culture"
    dataType="string"
    cellTemplate="cropTemplate"
    dataField="crop.name"
  >
    <div *dxTemplate="let cellInfo of 'cropTemplate'">
      <a
        href="#"
        (click)="showCropDetails($event, cellInfo.data)"
        [title]="cellInfo.data?.crop?.path_str"
        class="border-b border-dotted border-gray-700"
        >{{ cellInfo.value }}</a
      >
    </div>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Superficie Cultivée"
    width="8%"
    format="#0.## Ha"
    dataType="number"
    dataField="cadastral_area"
  >
    <dxo-form-item
      editorType="dxNumberBox"
      [editorOptions]="{ format: '#0.## Ha' }"
    ></dxo-form-item>
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxi-validation-rule
      type="range"
      [min]="0"
      [max]="field?.cadastral_area"
    ></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Couleur"
    width="auto"
    cellTemplate="colorTemplate"
    [allowSorting]="false"
    [allowFiltering]="false"
    dataField="color"
  >
    <div *dxTemplate="let cellInfo of 'colorTemplate'">
      <span
        style="width: 18px; height: 18px"
        class="block border border-solid border-gray-300 mx-2"
        [ngStyle]="{ backgroundColor: cellInfo.data.color || '#ffffff' }"
      ></span>
    </div>
    <dxo-form-item
      editorType="dxColorBox"
      [editorOptions]="{ openOnFieldClick: true, applyValueMode: 'instantly' }"
    ></dxo-form-item>
  </dxi-column>

  <dxi-column
    caption="Irriguée?"
    width="auto"
    [showEditorAlways]="false"
    falseText="Bour"
    trueText="Irriguée"
    editCellTemplate="irrigationEditor"
    dataType="boolean"
    dataField="is_irrigated"
  >
    <dxo-form-item editorType="dxCheckBox"></dxo-form-item>
    <div *dxTemplate="let cellInfo of 'irrigationEditor'">
      <div style="height: 35px" class="flex felx items-center h-full">
        <dx-switch
          [value]="cellInfo.value"
          (onValueChanged)="cellInfo.setValue($event.value)"
        ></dx-switch>
      </div>
    </div>
  </dxi-column>

  <dxi-column
    caption="Date Début"
    dataField="started_at"
    format="shortDate"
    dataType="date"
  >
    <dxo-form-item
      editorType="dxDateBox"
      [editorOptions]="{ type: 'date', openOnFieldClick: true }"
    ></dxo-form-item>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Date Fin Estimée"
    dataField="estimated_end_at"
    format="shortDate"
    dataType="date"
  >
    <dxo-form-item
      editorType="dxDateBox"
      [editorOptions]="{ type: 'date', openOnFieldClick: true }"
    ></dxo-form-item>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Date d'Archivage"
    [allowEditing]="false"
    [visible]="viewMode !== currentCampaign ? true : false"
    [formItem]="{ visible: false }"
    dataField="archived_at"
    format="shortDate"
    dataType="date"
  >
  </dxi-column>

  <dxi-column
    caption="Description"
    width="auto"
    [visible]="false"
    dataField="description"
  >
    <dxo-form-item
      editorType="dxTextArea"
      [editorOptions]="{ height: 70 }"
    ></dxo-form-item>
    <dxi-validation-rule type="stringLength" [max]="255"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    caption="Culture"
    dataField="crop_id"
    editCellTemplate="cropChooser"
    [visible]="false"
    [showInColumnChooser]="false"
  >
    <div *dxTemplate="let cellInfo of 'cropChooser'">
      <app-crop-selector
        [items]="crops | async"
        (selectionChanged)="cropSelected($event)"
        (valueChange)="cellInfo.setValue($event)"
        [value]="cellInfo.value"
      ></app-crop-selector>
    </div>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    *ngIf="cropCustomColumns.length > 0"
    [visible]="false"
    [showInColumnChooser]="false"
    [columns]="cropCustomColumns"
  >
  </dxi-column>

  <dxi-column
    caption="Campagne"
    dataField="campaign_id"
    editCellTemplate="campaignChooser"
    [visible]="false"
    [showInColumnChooser]="false"
  >
    <div *dxTemplate="let cellInfo of 'campaignChooser'">
      <app-campaign-selector
        [value]="cellInfo.value"
        (valueChange)="cellInfo.setValue($event)"
      ></app-campaign-selector>
    </div>
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column
    [visible]="viewMode === currentCampaign ? true : false"
    [showInColumnChooser]="false"
    type="buttons"
    [width]="110"
  >
    <dxi-button
      icon="ld-area"
      hint="Modifier la surface de la culture"
      [onClick]="openEditor"
    ></dxi-button>
    <dxi-button name="edit"></dxi-button>
    <dxi-button icon="ld-archive" hint="Archiver" name="delete"></dxi-button>
  </dxi-column>

  <dxi-column
    [visible]="viewMode !== currentCampaign ? true : false"
    [showInColumnChooser]="false"
    type="buttons"
    [width]="55"
  >
    <dxi-button
      icon="copy"
      hint="duplicate"
      [onClick]="cloneCulture"
    ></dxi-button>
  </dxi-column>

  <dxo-editing
    mode="popup"
    [allowDeleting]="true"
    [allowAdding]="true"
    [allowUpdating]="true"
    [selectTextOnEditStart]="true"
    [texts]="{
      confirmDeleteMessage: 'Voulez-vous vraiment archiver cette culture?'
    }"
  >
    <dxo-popup [showTitle]="false" width="40%"></dxo-popup>

    <dxo-form [colCount]="1">
      <dxi-item dataField="crop_id"></dxi-item>
      <dxi-item dataField="cadastral_area"></dxi-item>

      <dxi-item
        itemType="group"
        [items]="cropCustomColumns"
        colCount="2"
      ></dxi-item>

      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="started_at"></dxi-item>
        <dxi-item dataField="estimated_end_at"></dxi-item>
      </dxi-item>

      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="campaign_id"></dxi-item>
        <dxi-item dataField="is_irrigated"></dxi-item>
      </dxi-item>

      <dxi-item itemType="group" colCount="1">
        <dxi-item dataField="description"></dxi-item>
      </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

  <dxo-group-panel [visible]="false"></dxo-group-panel>

  <dxo-export
    [enabled]="true"
    fileName="liste-cultures-parcelles"
    [allowExportSelectedData]="true"
  ></dxo-export>

  <dxo-sorting mode="multiple"></dxo-sorting>

  <dxo-paging [pageSize]="25"></dxo-paging>

  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 100]"
    [showInfo]="true"
  >
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

  <dxo-header-filter [visible]="true"></dxo-header-filter>
</dx-data-grid>

<dx-popover
  [target]="rowEl"
  position="top"
  [width]="300"
  [(visible)]="cropDetailsPopupVisible"
>
  <div *dxTemplate="let data = model; of: 'content'">
    <span class="mb-3">{{ selectedCrop?.path_str }}</span>
    <div class="details-list p-3 mt-1">
      <ng-container *ngFor="let attr of cropCustomFieldPreview">
        <div [title]="attr.caption">{{ attr.caption }}</div>
        <div>{{ attr.value }}</div>
      </ng-container>
    </div>
  </div>
</dx-popover>
